import facebook_icon from '../../resource/img/facebook_icon.svg';
import kakaotalk_icon from '../../resource/img/kakaotalk_icon.svg';
import gmail_icon from '../../resource/img/gmail_icon.svg';
import admin_icon from '../../resource/img/admin_icon.png';

export const socialLink = {
    facebook: {
        icon: facebook_icon,
        address: 'https://www.facebook.com/INUAppCenter',
    },
    kakaotalk: {
        icon: kakaotalk_icon,
        address: 'https://pf.kakao.com/_xgxaSLd',
    },
    email: {
        icon: gmail_icon,
        address: 'mailto:inuappcenter@gmail.com',
    },
    admin: {
        icon: admin_icon,
        address: '/login',
    },
};
